webpackJsonp([0],{

/***/ 1508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _baguetteBox = __webpack_require__(375);

var _baguetteBox2 = _interopRequireDefault(_baguetteBox);

var _sections = __webpack_require__(649);

var _sections2 = _interopRequireDefault(_sections);

var _breakpointImageLoader = __webpack_require__(376);

var _breakpointImageLoader2 = _interopRequireDefault(_breakpointImageLoader);

var _multiStory = __webpack_require__(646);

var _multiStory2 = _interopRequireDefault(_multiStory);

var _storyLightBox = __webpack_require__(650);

var _storyLightBox2 = _interopRequireDefault(_storyLightBox);

var _gallerySwitcher = __webpack_require__(643);

var _gallerySwitcher2 = _interopRequireDefault(_gallerySwitcher);

var _main = __webpack_require__(645);

var _main2 = _interopRequireDefault(_main);

var _navigation = __webpack_require__(647);

var _navigation2 = _interopRequireDefault(_navigation);

var _youTubeTracking = __webpack_require__(651);

var _youTubeTracking2 = _interopRequireDefault(_youTubeTracking);

var _analyticsPage = __webpack_require__(642);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

var _advertisingStyles = __webpack_require__(641);

var _advertisingStyles2 = _interopRequireDefault(_advertisingStyles);

var _initPrices = __webpack_require__(644);

var _initPrices2 = _interopRequireDefault(_initPrices);

var _rpMqBreakpoints = __webpack_require__(36);

var rpBreakpoints = _interopRequireWildcard(_rpMqBreakpoints);

var _rpRaceDayLive = __webpack_require__(237);

var _rpCookie = __webpack_require__(50);

var _rpGuiGuide = __webpack_require__(129);

var rpGuiGuide = _interopRequireWildcard(_rpGuiGuide);

var _rpPopup = __webpack_require__(236);

var _rpPopup2 = _interopRequireDefault(_rpPopup);

var _rpAdvertising = __webpack_require__(235);

var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);

var _rpUrlNavigationPrefs = __webpack_require__(238);

var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);

var _rpBettingSpecialOffer = __webpack_require__(636);

var _rpBettingSpecialOffer2 = _interopRequireDefault(_rpBettingSpecialOffer);

var _ScribbleWidgetInteracter = __webpack_require__(648);

var _ScribbleWidgetInteracter2 = _interopRequireDefault(_ScribbleWidgetInteracter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { render as renderRdl } from 'rp-race-day-live';
function isMobileDevice() {
    return (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
}
// var PaidIcon from './paidIcon';


$(window).on('load', function () {
    /**
     * Clean-up legacy cookies
     */
    (0, _rpCookie.cleanLegacy)();
    /**
     * Initialize gui-guide scripts
     */
    rpGuiGuide.default({ svg: { polyfill: true } });
    /**
     * Initialize popup component
     */
    (0, _rpPopup2.default)();
    /**
     * Initialize advertising component
     */
    (0, _rpAdvertising2.default)();
    /**
     * Fire the analytics.page() event with the needed traits
     */
    (0, _analyticsPage2.default)();
    /**
     * Initialize betting special offer component
     */
    (0, _rpBettingSpecialOffer2.default)();
    /**
     * Initializing Cookie Policy
     */
    var navigation = new _navigation2.default();
    /**
     * Initialize Youtube tracking
     */
    (0, _youTubeTracking2.default)();

    window.rp1 = window.rp1 || {};
    window.rp1.assetsUrl = window.rp1.assetsUrl || ($('body').data('assetsUrl') !== '' ? $('body').data('assetsUrl') : '');
    (0, _rpUrlNavigationPrefs2.default)();

    // Paid icon hiding to logged premium users (NEWS-2051)
    /**
     * 2010-10-06: Feature temporary disabled according to Jira ticket below
     * @link https://racingpost.atlassian.net/browse/NEWS-2154
     */
    // new PaidIcon($, authReady);

    /**
     * Init Scribble Live Blog interacter
     * @link https://racingpost.atlassian.net/browse/QW-681
     */
    if ($('.scrbbl-embed').length > 0) {
        var scribbleWidgetInteracter = new _ScribbleWidgetInteracter2.default();
        scribbleWidgetInteracter.init();
    }

    // Race Day Live JS Component
    if ($('#rdl-content').length > 0) {
        var curMeeting = window.location.hash.replace('#', '').replace('meet', '');
        if (curMeeting !== '' && $('#rdl-filter-template > option[data-filter = ' + curMeeting + ']').length > 0) {
            $('#rdl-filter-template').val($('#rdl-filter-template > option[data-filter = ' + curMeeting + ']').val());
        }

        $('#rdl-filter-template').rpSelect();
        $('#rdl-filter-template').on('change', function (event, element) {
            var courseId = element.data('filter');
            if (typeof courseId !== 'undefined') {
                courseId = String(courseId);
            }
            $(window.document).trigger('filter.apply', [courseId]);
            if (!window.location.hash) {
                window.history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        });

        (0, _initPrices2.default)();

        var fakeDiffusion = $.cookie('fakeDiffusion') === '1';
        var RDL = new _rpRaceDayLive.RaceDayLive();

        if (fakeDiffusion) {
            RDL.config.headerSpinner.hide();
            window.rp1.fake = {};
            window.rp1.fake.rdl = RDL;
        } else {
            RDL.init();
        }

        // renderRdl(document.getElementById('rdl-content'));
    }

    // Index Page
    if ($('.content').data('index') !== undefined && $('.content').data('url') !== undefined) {
        var section = (0, _sections2.default)($, _breakpointImageLoader2.default);
        section.showMoreDisplay(_main2.default);
        section.startHashClickHandle('a[data-js-class="menu-anchor"]');
        navigation.handleBreakpointChange('More');
        (0, _advertisingStyles2.default)();
    }

    // MultiTab Page
    if ($('#js-multiStoryTabs').length > 0) {
        if (window.location.hash.length && window.location.hash.substr(0, 5) === '#tab-') {
            var tab = parseInt(window.location.hash.substr(5));
            var i = (isNaN(tab) ? 1 : tab) - 1;
            (0, _multiStory2.default)($('ul.tabs').find('a.tabs__link').get(i));
        }
        $('ul.tabs').find('a.tabs__link').click(function () {
            return (0, _multiStory2.default)(this);
        });
    }

    // Story Page
    if ($('.story').length > 0) {
        var lightboxes = [],
            currentBpMaxValue = rpBreakpoints.default.current().max,
            narrowToMediumMediaValue = 719;

        var initLightboxes = function initLightboxes() {
            lightboxes[0] = new _storyLightBox2.default($, _baguetteBox2.default, $('.js-main-gallery').attr('id'));
            $('.js-body-gallery').each(function () {
                lightboxes[lightboxes.length] = new _storyLightBox2.default($, _baguetteBox2.default, $(this)[0].id);
            });
        };

        var overLayHandler = function overLayHandler(visibility) {
            if (visibility) {
                $('#baguetteBox-overlay').show();
            } else {
                $('#baguetteBox-overlay').hide();
            }
        };

        /*
         * This part of code fix bug with incorrect displaying lightbox when user change breakpoints
         * On exNarrow and Narrow baguetteBox-top-overlay element hidden(id changed to baguetteBox-top-overlay-hidden)
         * On Medium and above breakpoints baguetteBox-top-overlay is visible
         */
        var baguetteBoxTreatment = function baguetteBoxTreatment(breakPointValue) {
            var visibleOverlayClass = 'baguetteBox-top-overlay',
                hiddenOverlayClass = 'baguetteBox-top-overlay-hidden',
                visibleOverlaySelector = '#baguetteBox-top-overlay',
                hiddenOverlaySelector = '#baguetteBox-top-overlay-hidden',
                slideShowBylineAndImageSelector = '.slideShow__byline, .js-imageLoader',
                baguetteBoxOverlaySelector = '#baguetteBox-overlay',
                currentBreakPoint = breakPointValue || rpBreakpoints.default.current().max,
                storyGalleryImage = '.storyGallery__item__image',
                icoSelectorList = '.js-gallerySwitchIco-List',
                icoActiveClass = 'gallerySwitch__link-active',
                gallerySelector = '.js-main-gallery',
                galleryClassThumbs = 'storyGallery-tiles',
                galleryClassList = 'storyGallery-list';

            if (currentBreakPoint > narrowToMediumMediaValue) {
                if (!lightboxes.length) {
                    initLightboxes();
                }

                $(hiddenOverlaySelector).removeClass('visible').attr('style', '').attr('id', visibleOverlayClass);
                $(slideShowBylineAndImageSelector).on('click', function () {
                    overLayHandler(true);
                });
                $(baguetteBoxOverlaySelector).show();
            } else {
                $(baguetteBoxOverlaySelector).hide();
                $(visibleOverlaySelector).attr('id', hiddenOverlayClass).hide();
                $(slideShowBylineAndImageSelector).on('click', function () {
                    overLayHandler(false);
                });

                $(icoSelectorList).addClass(icoActiveClass).siblings().removeClass(icoActiveClass);
                $(gallerySelector).removeClass(galleryClassThumbs).addClass(galleryClassList);
            }
        };

        initLightboxes();
        baguetteBoxTreatment();

        $(window).on('rpBreakpointsSwitch', function (event) {
            baguetteBoxTreatment(event.detail.breakpoint.max);
        });

        if ($('.story .betBlock').length > 0) {
            $('.js-diffusionTopicSettingsRace').attr('data-diffusion-racedate', $('.betBlock:first').data('diffusion-racedate'));
            (0, _initPrices2.default)();
            $.event.trigger('dynamicPricesUpdated.PRICES');
        }

        $('.classToggler').click(function () {
            $(this).parent().toggleClass('active');
            return false;
        });

        // modifying breakpoint behavior for galleryStoryGallery
        var respGallery = new _breakpointImageLoader2.default($('.js-galleryImg'), $);
        respGallery.config = {
            extraNarrow: 'br-n',
            narrow: 'br-n',
            medium: 'br-n',
            wide: 'br-m',
            extraWide: 'br-n'
        };
        respGallery.changeCallback = function (image, nextImg) {
            if (image.children('img').attr('src') !== nextImg) {
                image.children('img').attr('src', nextImg);
            }
        };
        respGallery.BreakPointListener();

        if ($('.js-story-gallery').length > 0) {
            (0, _gallerySwitcher2.default)($, {}, respGallery);
        }

        var responsiveAll = new _breakpointImageLoader2.default($('.js-imageLoader'), $);
        responsiveAll.BreakPointListener();
    }

    // hide sotial icons for non mobile devices
    if (!isMobileDevice()) {
        $('.socialLinks__item--whatsapp').hide();
        $('.socialLinks__item--messenger').hide();
    }
});

/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(170);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(171);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__(12);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BetslipInteracter = function () {
    function BetslipInteracter() {
        (0, _classCallCheck3.default)(this, BetslipInteracter);

        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    (0, _createClass3.default)(BetslipInteracter, [{
        key: 'init',
        value: function init(feedName) {
            var deferred = _jquery2.default.Deferred();
            this.resolvePromise = deferred.resolve;
            var customizeSettingsCookie = _jquery2.default.cookie('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            if (feedName) {
                this.feedName = feedName;
                this.setBetslipBookmaker(feedName);
            } else {
                this.requestSelectedBookmaker();
            }
            return deferred.promise();
        }
    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(_ref) {
            var bookmaker = _ref.detail.bookmaker;

            (0, _jquery2.default)(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
            this.resolveBookmaker(bookmaker);
        }
    }, {
        key: 'resolveBookmaker',
        value: function resolveBookmaker(bookmaker) {
            if (this.resolvePromise) {
                this.resolvePromise(bookmaker);
                this.resolvePromise = null;
                delete this.resolvePromise;
            }
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            if (this.feedName) {
                this.setBetslipBookmaker(this.feedName);
                this.resolveBookmaker(this.feedName);
            } else {
                this.requestSelectedBookmaker();
            }
        }
    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'setBetslipBookmaker',
        value: function setBetslipBookmaker(bookmaker) {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: bookmaker }
            });
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }]);
    return BetslipInteracter;
}();

exports.default = BetslipInteracter;

/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    MESSAGE: 'message',
    SCRIBBLE_INITIALIZED: 'SCRIBBLE.INITIALIZED',
    BETSLIP_INITIALIZED: 'BETSLIP.INITIALIZED',
    BETSLIP_BOOKMAKER_GET: 'BETSLIP.BOOKMAKER.GET',
    BETSLIP_BOOKMAKER: 'BETSLIP.BOOKMAKER',
    BETSLIP_BOOKMAKER_CHANGED: 'BETSLIP.BOOKMAKER_CHANGED',
    BETSLIP_MAKE_SELECTION: 'BETSLIP.MAKE_SELECTION'
};

/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CONFIGURATION_DOM_SELECTOR = '.js-diffusionTopicSettings';
var CONFIGURATION_HOST_PROPERTY = 'data-diffusion-host';
var CONFIGURATION_PORT_PROPERTY = 'data-diffusion-port';
var CONFIGURATION_STUB_URL_PROPERTY = 'data-diffusion-stub-url';
var CONFIGURATION_PPWR_FEED_PROPERTY = 'data-diffusion-feed-ppwr';

exports.default = function () {
    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : parent.document;

    var diffusionServerConfig = target.querySelector(CONFIGURATION_DOM_SELECTOR);
    if (!diffusionServerConfig) {
        console.error('There is no diffusion configuration node');
        return {};
    }
    return {
        host: diffusionServerConfig.getAttribute(CONFIGURATION_HOST_PROPERTY),
        port: diffusionServerConfig.getAttribute(CONFIGURATION_PORT_PROPERTY),
        url: diffusionServerConfig.getAttribute(CONFIGURATION_STUB_URL_PROPERTY),
        ppwr: diffusionServerConfig.getAttribute(CONFIGURATION_PPWR_FEED_PROPERTY)
    };
};

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * baguetteBox.js
 * @author  feimosi
 * @version 1.4.0
 * @url https://github.com/feimosi/baguetteBox.js
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(132);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baguetteBox = function baguetteBox() {
    window.rp1 = window.rp1 || {};
    window.rp1.assetsUrl = window.rp1.assetsUrl || ('assets-url' in $('body').data() ? $('body').data('assets-url') : '');

    // SVG shapes used on the buttons
    var leftArrow = '<svg class="ui-icon ui-icon_sizeMedium baguetteBox__icon-left"><use xlink:href="' + window.rp1.assetsUrl + 'img/icons.svg#icon-left"/></svg>',
        rightArrow = '<svg class="ui-icon ui-icon_sizeMedium baguetteBox__icon-right"><use xlink:href="' + window.rp1.assetsUrl + 'img/icons.svg#icon-right"/></svg>',
        closeX = '<svg class="ui-icon ui-icon_sizeMedium baguetteBox__icon-cross"><use xlink:href="' + window.rp1.assetsUrl + 'img/icons.svg#icon-cross"/></svg>';
    // Global options and their defaults
    var options = {},
        defaults = {
        captions: true,
        buttons: 'auto',
        async: false,
        preload: 2,
        animation: 'slideIn',
        afterShow: null,
        afterHide: null,
        // callback when image changes with `currentIndex` and `imagesElements.length` as parameters
        onChange: null
    };
    // Object containing information about features compatibility
    var supports = {};
    // DOM Elements references
    var top_overlay, overlay, slider, previousButton, nextButton, closeButton;
    // Current image index inside the slider and displayed gallery index
    var currentIndex = 0,
        currentGallery = -1;
    // Touch event start position (for slide gesture)
    var touchStartX;
    // If set to true ignore touch events because animation was already fired
    var touchFlag = false;
    // Regex pattern to match image files
    var regex = /.+\.(gif|jpe?g|png|webp)/i;
    // Array of all used galleries (DOM elements)
    var galleries = [];
    // 2D array of galleries and images inside them
    var imagesMap = [];
    // Array containing temporary images DOM elements
    var imagesElements = [];
    // Event handlers
    var imagedEventHandlers = {};
    //Fixed definitions
    var touch, nav_overlay, sliderWrapper, numerationDiv, imageElement, imageCaption, imageSrc;
    var overlayClickHandler = function overlayClickHandler(event) {
        // When clicked on the overlay (outside displayed image) close it
        if (event.target && event.target.nodeName !== 'IMG' && event.target.nodeName !== 'FIGCAPTION' && event.target.getAttribute('id') !== 'baguetteBox-overlay' && event.target.parentNode.getAttribute('id') !== 'baguetteBox-overlay' && event.target.getAttribute('id') !== 'baguetteBox-nav-overlay' && event.target.parentNode.getAttribute('id') !== 'baguetteBox-overlay' && event.target.getAttribute('id') !== 'baguetteBox-num') hideOverlay();
    };
    var previousButtonClickHandler = function previousButtonClickHandler(event) {
        /*jshint -W030 */
        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
        showPreviousImage();
    };
    var nextButtonClickHandler = function nextButtonClickHandler(event) {
        /*jshint -W030 */
        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
        showNextImage();
    };
    var closeButtonClickHandler = function closeButtonClickHandler(event) {
        /*jshint -W030 */
        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
        hideOverlay();
    };
    var touchstartHandler = function touchstartHandler(event) {
        // Save x axis position
        touchStartX = event.changedTouches[0].pageX;
    };
    var touchmoveHandler = function touchmoveHandler(event) {
        // If action was already triggered return
        if (touchFlag) return;

        /*jshint -W030 */
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
        touch = event.changedTouches[0] || event.touches[0];
        // Move at least 40 pixels to trigger the action
        if (touch.pageX - touchStartX > 40) {
            touchFlag = true;
            showPreviousImage();
        } else if (touch.pageX - touchStartX < -40) {
            touchFlag = true;
            showNextImage();
        }
    };
    var touchendHandler = function touchendHandler(event) {
        touchFlag = false;
    };

    // forEach polyfill for IE8
    // http://stackoverflow.com/a/14827443/1077846
    if (![].forEach) {
        Array.prototype.forEach = function (callback, thisArg) {
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    // filter polyfill for IE8
    // https://gist.github.com/eliperelman/1031656
    if (![].filter) {
        Array.prototype.filter = function (a, b, c, d, e) {
            /*jshint -W030 */
            c = this;d = [];for (e = 0; e < c.length; e++) {
                a.call(b, c[e], e, c) && d.push(c[e]);
            }return d;
        };
    }

    // Script entry point
    function run(selector, userOptions) {
        // Fill supports object
        supports.transforms = testTransformsSupport();
        supports.svg = testSVGSupport();

        buildOverlay();
        bindImageClickListeners(selector, userOptions);
    }

    function bindImageClickListeners(selector, userOptions) {
        // For each gallery bind a click event to every image inside it
        galleries = document.querySelectorAll(selector);
        [].forEach.call(galleries, function (galleryElement) {
            if (userOptions && userOptions.filter) regex = userOptions.filter;
            // Filter 'a' elements from those not linking to images
            var tags = galleryElement.getElementsByTagName('a');
            tags = [].filter.call(tags, function (element) {
                return regex.test(element.href);
            });

            // Get all gallery images and save them in imagesMap with custom options
            var galleryID = imagesMap.length;
            imagesMap.push(tags);
            imagesMap[galleryID].options = userOptions;

            [].forEach.call(imagesMap[galleryID], function (imageElement, imageIndex) {
                var imageElementClickHandler = function imageElementClickHandler(event) {
                    /*jshint -W030 */
                    event.preventDefault ? event.preventDefault() : event.returnValue = false;
                    prepareOverlay(galleryID);
                    showOverlay(imageIndex);
                };
                imagedEventHandlers[imageElement] = imageElementClickHandler;
                bind(imageElement, 'click', imageElementClickHandler);
            });
        });
    }

    function unbindImageClickListeners() {
        [].forEach.call(galleries, function (galleryElement) {
            var galleryID = imagesMap.length - 1;
            [].forEach.call(imagesMap[galleryID], function (imageElement, imageIndex) {
                unbind(imageElement, 'click', imagedEventHandlers[imageElement]);
            });
            imagesMap.pop();
        });
    }

    function buildOverlay() {
        top_overlay = getByID('baguetteBox-top-overlay');
        overlay = getByID('baguetteBox-overlay');
        // Check if the overlay already exists
        if (overlay) {
            slider = getByID('baguetteBox-slider');
            previousButton = getByID('previous-button');
            nextButton = getByID('next-button');
            closeButton = getByID('close-button');
            return;
        }
        // Create overlay element
        top_overlay = create('div');
        top_overlay.id = 'baguetteBox-top-overlay';
        document.getElementsByTagName('body')[0].appendChild(top_overlay);

        // Create sub-overlay element
        overlay = create('div');
        overlay.id = 'baguetteBox-overlay';
        top_overlay.appendChild(overlay);

        // Create overlay for buttons and numeration
        nav_overlay = create('div');
        nav_overlay.id = 'baguetteBox-nav-overlay';
        overlay.appendChild(nav_overlay);

        // Create gallery slider element
        sliderWrapper = create('div');
        sliderWrapper.className = 'baguetteBox-slider-wrapper';
        overlay.appendChild(sliderWrapper);

        // Create gallery slider element
        slider = create('div');
        slider.id = 'baguetteBox-slider';
        sliderWrapper.appendChild(slider);

        // Create all necessary buttons+
        previousButton = create('button');
        previousButton.id = 'previous-button';
        previousButton.innerHTML = supports.svg ? leftArrow : '&lt;';
        nav_overlay.appendChild(previousButton);

        // Crate block for numeration text
        numerationDiv = create('div');
        numerationDiv.id = 'baguetteBox-num';
        nav_overlay.appendChild(numerationDiv);

        nextButton = create('button');
        nextButton.id = 'next-button';
        nextButton.innerHTML = supports.svg ? rightArrow : '&gt;';
        nav_overlay.appendChild(nextButton);

        closeButton = create('button');
        closeButton.id = 'close-button';
        closeButton.innerHTML = supports.svg ? closeX : 'X';
        nav_overlay.appendChild(closeButton);

        previousButton.className = nextButton.className = closeButton.className = 'baguetteBox-button';

        bindEvents();
    }

    function keyDownHandler(event) {
        switch (event.keyCode) {
            case 37:
                // Left arrow
                showPreviousImage();
                break;
            case 39:
                // Right arrow
                showNextImage();
                break;
            case 27:
                // Esc
                hideOverlay();
                break;
        }
    }

    function bindEvents() {
        document.body.addEventListener('touchstart', function () {});

        bind(top_overlay, 'click', overlayClickHandler);
        bind(previousButton, 'click', previousButtonClickHandler);
        bind(nextButton, 'click', nextButtonClickHandler);
        bind(closeButton, 'click', closeButtonClickHandler);
        bind(overlay, 'touchstart', touchstartHandler);
        bind(overlay, 'touchmove', touchmoveHandler);
        bind(overlay, 'touchend', touchendHandler);
    }

    function unbindEvents() {
        document.body.removeEventListener('touchstart', function () {});

        unbind(top_overlay, 'click', overlayClickHandler);
        unbind(previousButton, 'click', previousButtonClickHandler);
        unbind(nextButton, 'click', nextButtonClickHandler);
        unbind(closeButton, 'click', closeButtonClickHandler);
        unbind(overlay, 'touchstart', touchstartHandler);
        unbind(overlay, 'touchmove', touchmoveHandler);
        unbind(overlay, 'touchend', touchendHandler);
    }

    function prepareOverlay(galleryIndex) {
        // If the same gallery is being opened prevent from loading it once again
        if (currentGallery === galleryIndex) return;
        currentGallery = galleryIndex;
        // Update gallery specific options
        setOptions(imagesMap[galleryIndex].options);
        // Empty slider of previous contents (more effective than .innerHTML = "")
        while (slider.firstChild) {
            slider.removeChild(slider.firstChild);
        }imagesElements.length = 0;
        // Prepare and append images containers
        for (var i = 0, fullImage; i < imagesMap[galleryIndex].length; i++) {
            fullImage = create('div');
            fullImage.className = 'full-image';
            fullImage.id = 'baguette-img-' + i;
            imagesElements.push(fullImage);
            slider.appendChild(imagesElements[i]);
        }
    }

    function setOptions(newOptions) {
        if (!newOptions) newOptions = {};
        // Fill options object
        for (var item in defaults) {
            options[item] = defaults[item];
            if (typeof newOptions[item] !== 'undefined') options[item] = newOptions[item];
        }
        /* Apply new options */
        // Change transition for proper animation
        slider.style.transition = slider.style.webkitTransition = options.animation === 'fadeIn' ? 'opacity .4s ease' : options.animation === 'slideIn' ? '' : 'none';
        // Hide buttons if necessary
        if (options.buttons === 'auto' && ('ontouchstart' in window || imagesMap[currentGallery].length === 1)) options.buttons = false;
        // Set buttons style to hide or display them
        previousButton.style.display = nextButton.style.display = options.buttons ? '' : 'none';
    }

    function showOverlay(chosenImageIndex) {
        if (top_overlay.style.display === 'block') return;

        bind(document, 'keydown', keyDownHandler);
        currentIndex = chosenImageIndex;
        loadImage(currentIndex, function () {
            preloadNext(currentIndex);
            preloadPrev(currentIndex);
        });

        updateOffset();
        top_overlay.style.display = 'block';
        // Fade in overlay
        setTimeout(function () {
            top_overlay.className = 'visible';
            if (options.afterShow) options.afterShow();
        }, 50);
        if (options.onChange) options.onChange(currentIndex, imagesElements.length);
    }

    function hideOverlay() {
        if (top_overlay.style.display === 'none') return;

        unbind(document, 'keydown', keyDownHandler);
        // Fade out and hide the overlay
        top_overlay.className = '';
        setTimeout(function () {
            top_overlay.style.display = 'none';
            if (options.afterHide) options.afterHide();
        }, 500);
    }

    function loadImage(index, callback) {
        var imageContainer = imagesElements[index];
        if (typeof imageContainer === 'undefined') return;

        // If image is already loaded run callback and return
        if (imageContainer.getElementsByTagName('img')[0]) {
            if (callback) callback();
            return;
        }
        // Get element reference, optional caption and source path
        imageElement = imagesMap[currentGallery][index];
        imageCaption = typeof options.captions === 'function' ? options.captions.call(imagesMap[currentGallery], imageElement) : imageElement.getAttribute('data-caption') || imageElement.title;
        imageSrc = getImageSrc(imageElement);
        // Prepare image container elements
        var figure = create('figure');
        var image = create('img');
        var figcaption = create('figcaption');
        imageContainer.appendChild(figure);
        // Add loader element
        figure.innerHTML = '<div class="spinner">' + '<div class="double-bounce1"></div>' + '<div class="double-bounce2"></div>' + '</div>';
        // Set callback function when image loads
        image.onload = function () {
            // Remove loader element
            var spinner = document.querySelector('#baguette-img-' + index + ' .spinner');
            if (spinner !== null) figure.removeChild(spinner);
            if (!options.async && callback) callback();
        };
        image.setAttribute('src', imageSrc);
        figure.appendChild(image);
        // Insert caption if available
        if (options.captions && imageCaption) {
            figcaption.innerHTML = imageCaption;
            figure.appendChild(figcaption);
        }
        // Run callback
        if (options.async && callback) callback();
    }

    // Get image source location, mostly used for responsive images
    function getImageSrc(image) {
        // Set default image path from href
        var result = imageElement.href;
        // If dataset is supported find the most suitable image
        if (image.dataset) {
            var srcs = [];
            // Get all possible image versions depending on the resolution
            for (var item in image.dataset) {
                if (item.substring(0, 3) === 'at-' && !isNaN(item.substring(3))) srcs[item.replace('at-', '')] = image.dataset[item];
            }
            // Sort resolutions ascending
            var keys = (0, _keys2.default)(srcs).sort(function (a, b) {
                return parseInt(a) < parseInt(b) ? -1 : 1;
            });
            // Get real screen resolution
            var width = window.innerWidth * window.devicePixelRatio;
            // Find the first image bigger than or equal to the current width
            var i = 0;
            while (i < keys.length - 1 && keys[i] < width) {
                i++;
            }result = srcs[keys[i]] || result;
        }
        return result;
    }

    // Return false at the right end of the gallery
    function showNextImage() {
        var returnValue;
        // Check if next image exists
        if (currentIndex <= imagesElements.length - 2) {
            currentIndex++;
            updateOffset();
            preloadNext(currentIndex);
            returnValue = true;
        } else if (options.animation) {
            slider.className = 'bounce-from-right';
            setTimeout(function () {
                slider.className = '';
            }, 400);
            returnValue = false;
        }
        if (options.onChange) options.onChange(currentIndex, imagesElements.length);
        return returnValue;
    }

    // Return false at the left end of the gallery
    function showPreviousImage() {
        var returnValue;
        // Check if previous image exists
        if (currentIndex >= 1) {
            currentIndex--;
            updateOffset();
            preloadPrev(currentIndex);
            returnValue = true;
        } else if (options.animation) {
            slider.className = 'bounce-from-left';
            setTimeout(function () {
                slider.className = '';
            }, 400);
            returnValue = false;
        }
        if (options.onChange) options.onChange(currentIndex, imagesElements.length);
        return returnValue;
    }

    function updateOffset() {
        var offset = -currentIndex * 100 + '%';
        if (options.animation === 'fadeIn') {
            slider.style.opacity = 0;
            setTimeout(function () {
                /*jshint -W030 */
                supports.transforms ? slider.style.transform = slider.style.webkitTransform = 'translateX(' + offset + ')' : slider.style.left = offset;
                slider.style.opacity = 1;
            }, 400);
        } else {
            /*jshint -W030 */
            supports.transforms ? slider.style.transform = slider.style.webkitTransform = 'translateX(' + offset + ')' : slider.style.left = offset;
        }
    }

    // CSS 3D Transforms test
    function testTransformsSupport() {
        var div = create('div');
        return typeof div.style.perspective !== 'undefined' || typeof div.style.webkitPerspective !== 'undefined';
    }

    // Inline SVG test
    function testSVGSupport() {
        var div = create('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) == 'http://www.w3.org/2000/svg';
    }

    function preloadNext(index) {
        if (index - currentIndex >= options.preload) return;
        loadImage(index + 1, function () {
            preloadNext(index + 1);
        });
    }

    function preloadPrev(index) {
        if (currentIndex - index >= options.preload) return;
        loadImage(index - 1, function () {
            preloadPrev(index - 1);
        });
    }

    function bind(element, event, callback) {
        if (element.addEventListener) element.addEventListener(event, callback, false);else // IE8 fallback
            element.attachEvent('on' + event, callback);
    }

    function unbind(element, event, callback) {
        if (element.removeEventListener) element.removeEventListener(event, callback, false);else // IE8 fallback
            element.detachEvent('on' + event, callback);
    }

    function getByID(id) {
        return document.getElementById(id);
    }

    function create(element) {
        return document.createElement(element);
    }

    function destroyPlugin() {
        unbindEvents();
        unbindImageClickListeners();
        unbind(document, 'keydown', keyDownHandler);
        document.getElementsByTagName('body')[0].removeChild(document.getElementById('baguetteBox-top-overlay'));
        currentIndex = 0;
        currentGallery = -1;
        galleries = [];
        imagesMap = [];
    }

    return {
        run: run,
        destroy: destroyPlugin,
        showNext: showNextImage,
        showPrevious: showPreviousImage
    };
};

exports.default = new baguetteBox();

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(132);

var _keys2 = _interopRequireDefault(_keys);

var _maxSafeInteger = __webpack_require__(382);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _enquire = __webpack_require__(372);

var _enquire2 = _interopRequireDefault(_enquire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function responsive(images, $) {
    var context = {};

    context.breakPoints = [{
        min: 0,
        max: 479,
        mediaQuery: '(max-width: 29.999em)',
        toString: function toString() {
            return 'extraNarrow';
        }
    }, {
        min: 480,
        max: 719,
        mediaQuery: '(min-width: 30em) and (max-width: 44.999em)',
        toString: function toString() {
            return 'narrow';
        }
    }, {
        min: 720,
        max: 989,
        mediaQuery: '(min-width: 45em) and (max-width: 61.874em)',
        toString: function toString() {
            return 'medium';
        }
    }, {
        min: 990,
        max: 1255,
        mediaQuery: '(min-width: 61.875em) and (max-width: 78.499em)',
        toString: function toString() {
            return 'wide';
        }
    }, {
        min: 1256,
        max: _maxSafeInteger2.default || Number.MAX_VALUE,
        mediaQuery: '(min-width: 78.5em)',
        toString: function toString() {
            return 'extraWide';
        }
    }];

    context.currentBreakPoint = null;

    context.config = {
        extraNarrow: 'br-xn',
        narrow: 'br-n',
        medium: 'br-m',
        wide: 'br-w',
        extraWide: 'br-xw'
    };

    context.BreakPointListener = function () {
        context.onBreakPointChange = function (breakPointObj) {
            if (breakPointObj !== context.currentBreakPoint) {
                $(window.document).trigger('breakPoint.changed', [breakPointObj, context.currentBreakPoint]);
                context.currentBreakPoint = breakPointObj;
            }
        };

        function tempBP(breakPointObj) {
            _enquire2.default.register(breakPointObj.mediaQuery, function () {
                context.onBreakPointChange(breakPointObj);
            });
        }

        for (var breakPointId in context.breakPoints) {
            var breakPoint = context.breakPoints[breakPointId];
            tempBP(breakPoint);
        }
    };

    /*
    * Loop through all breakpoint sized and call change image method to each item
    * @param sizes Array of all breakpoint sizes
    */
    context.changeImagesOnShowMoreClick = function (sizes) {
        context.BreakPointListener();
        var keys = (0, _keys2.default)(sizes);

        for (var key in keys) {
            var cls = keys[key];
            context.config = sizes[cls];
            context.changeSourceOfImage($(cls));
        }
    };

    /*
     * Loop through all images and call change src attribute
     * @param images Jquery selection with images
     */
    context.changeSourceOfImage = function (images) {
        $.each(images, function (key, value) {
            var image = $(images[key]);
            context.changeCallback(image, image.data(context.config[context.currentBreakPoint.toString()]));
        });
    };

    context.changeCallback = function (image, nextImg, oldImg) {
        if (image.attr('src') !== nextImg) {
            image.attr('src', nextImg);
        }
    };

    $(window.document).on('breakPoint.changed', function (event, newBreakPoint, oldBreakPoint) {
        $.each(images, function (key, value) {
            var image = $(images[key]);
            context.changeCallback(image, image.data(context.config[newBreakPoint.toString()]), oldBreakPoint ? image.data(context.config[oldBreakPoint.toString()]) : '');
        });
    });

    return context;
}

exports.default = responsive;

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(71));
	else if(typeof define === 'function' && define.amd)
		define(["rp-analytics"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initBookmakerRegPanel;

var _rpAnalytics = __webpack_require__(1);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

__webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function initBookmakerRegPanel() {
    var openedBookmakerClass = 'rh-bookmaker--open';
    var hiddenPanelClass = 'rh-bookmakers--hidden';
    var isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);

    if (isMobile) {
        Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
            return webBookmakersNode.remove();
        });
    }

    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmakers__heading--mobile')).forEach(function (mobileHeaderNode) {
        return mobileHeaderNode.addEventListener('click', function () {
            var bookmakersNode = mobileHeaderNode.parentNode.parentNode;

            if (bookmakersNode.classList.contains(hiddenPanelClass)) {
                bookmakersNode.classList.remove(hiddenPanelClass);

                SegmentIO.trackOfferAccordionOpened(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));

                return;
            }

            bookmakersNode.classList.add(hiddenPanelClass);

            SegmentIO.trackOfferAccordionClosed(_defineProperty({}, SegmentIO.TRAIT_ACCORDION_NAME, 'Today\'s Bookmaker Offers'));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).forEach(function (headerNode) {
        return headerNode.addEventListener('click', function () {
            var _SegmentIO$trackOffer4;

            var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
            var bookmakerNode = headerNode.parentNode;
            var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
            var index = Number(bookmakerNode.getAttribute('data-index')) + 1;

            if (openedBookmakerNodes.length > 0) {
                Array.from(openedBookmakerNodes).forEach(function (node) {
                    var offerLabel = node.querySelector('.rh-bookmaker__view-offer>span');
                    offerLabel.innerHTML = 'View offer';
                    node.classList.remove(openedBookmakerClass);
                });
            }

            if (!isBookmakerNodeOpened) {
                var _SegmentIO$trackOffer3;

                bookmakerNode.classList.add(openedBookmakerClass);
                SegmentIO.trackOfferAccordionOpened((_SegmentIO$trackOffer3 = {}, _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer3, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer3));
                bookmakerNode.querySelector('.rh-bookmaker__view-offer>span').innerHTML = 'Hide offer';

                return;
            }

            SegmentIO.trackOfferAccordionClosed((_SegmentIO$trackOffer4 = {}, _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_ACCORDION_NAME, bookmakerNode.getAttribute('data-name')), _defineProperty(_SegmentIO$trackOffer4, SegmentIO.TRAIT_POSITION, index), _SegmentIO$trackOffer4));
        });
    });

    Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn')).forEach(function (el) {
        return el.addEventListener('click', function () {
            var _SegmentIO$trackBetti;

            SegmentIO.trackBettingOfferClick((_SegmentIO$trackBetti = {}, _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_BOOKMAKER, el.getAttribute('data-name')), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_LOCATION, 'Panel'), _defineProperty(_SegmentIO$trackBetti, SegmentIO.TRAIT_POSITION, Number(el.getAttribute('data-index')) + 1), _SegmentIO$trackBetti));
        });
    });
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=rpbettingspecialoffer.js.map

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpMqBreakpoints = __webpack_require__(36);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigationSelector = '.rn-navigation.rn-wrapper';

function calcTopShift() {
    var nav = $(navigationSelector);
    return Array.prototype.reduce.call(nav, function (sum, menu) {
        return sum + $(menu).height();
    }, 0);
}

function onBreakpointChange(e) {
    if (e.detail.breakpoint.code === 'xw') {
        setTopShift();
        window.removeEventListener('rpBreakpointsSwitch', onBreakpointChange);
    }
}

function setTopShift() {
    var styleEl = document.createElement('style');
    document.head.appendChild(styleEl);

    var shiftSize = calcTopShift();
    var rule = '@media (min-width: 1278px) {\n        .ui-advertising__skinsWrp_secNav .ui-advertising_position40,\n        .ui-advertising__skinsWrp_secNav .ui-advertising_position41 {\n            top: -' + shiftSize + 'px!important;\n        }}';

    styleEl.sheet.insertRule(rule, styleEl.sheet.cssRules.length);
}

function initAdvertisingStyles() {
    if (_rpMqBreakpoints2.default.current().code === 'xw') {
        setTopShift();
        return;
    }
    window.addEventListener('rpBreakpointsSwitch', onBreakpointChange);
}

exports.default = initAdvertisingStyles;

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(1);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = analyticsPage;

var _jquery = __webpack_require__(12);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAnalytics = __webpack_require__(71);

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function analyticsPage() {
    var _segmentio$setCommonT;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var pageTraits = {};
    var permutiveProps = { article: {} };
    var hasPermutiveProps = false;

    segmentio.setCommonTraits((_segmentio$setCommonT = {}, (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, (0, _jquery2.default)('[data-site-section]').attr('data-site-section')), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, (0, _jquery2.default)('[data-site-sub-section-1]').attr('data-site-sub-section-1')), (0, _defineProperty3.default)(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, (0, _jquery2.default)('[data-site-sub-section-2]').attr('data-site-sub-section-2')), _segmentio$setCommonT));

    var articleId = (0, _jquery2.default)('[data-article-id]').attr('data-article-id');
    var articlePublishedDate = (0, _jquery2.default)('[data-article-published-date]').attr('data-article-published-date');
    var originalArticlePublishedDate = (0, _jquery2.default)('[data-article-original-published-date]').attr('data-article-original-published-date');
    var articleName = (0, _jquery2.default)('[data-article-name]').attr('data-article-name');
    var articleAuthor = (0, _jquery2.default)('[data-article-author]').attr('data-article-author');

    if (articleId) {
        pageTraits['Article ID'] = articleId;
        permutiveProps.article.id = articleId;
        hasPermutiveProps = true;
    }

    if (articlePublishedDate) {
        pageTraits['Article Published Date'] = articlePublishedDate;
        permutiveProps.article.publishedAt = articlePublishedDate;
        hasPermutiveProps = true;
    }

    if (originalArticlePublishedDate) {
        pageTraits['Original Article Published Date'] = originalArticlePublishedDate;
        permutiveProps.article.OriginalPublishedAt = originalArticlePublishedDate;
        hasPermutiveProps = true;
    }

    if (articleName) {
        pageTraits['Article Name'] = articleName;
        permutiveProps.article.title = articleName;
        hasPermutiveProps = true;
    }

    if (articleAuthor) {
        pageTraits['Article Author'] = articleAuthor;
        permutiveProps.article.authors = [articleAuthor];
        hasPermutiveProps = true;
    }

    pageTraits = _jquery2.default.extend({}, traits, pageTraits);
    permutiveProps = hasPermutiveProps ? permutiveProps : {};

    var pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS, permutiveProps);
}

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gallerySwitcher = function gallerySwitcher($, newConfig, responsive) {
    var context = {};
    context.config = {
        gallerySelector: '.js-main-gallery',
        icoSelectorThumbs: '.js-gallerySwitchIco-Thumbs',
        icoSelectorList: '.js-gallerySwitchIco-List',
        icoActiveClass: 'ui-btn_major',
        galleryClassThumbs: 'storyGallery-tiles',
        galleryClassList: 'storyGallery-list'
    };

    $.extend(context.config, newConfig);

    $(context.config.icoSelectorThumbs).on('click', function (e) {
        e.preventDefault();
        if (!$(context.config.icoSelectorThumbs).hasClass(context.config.icoActiveClass)) {
            $(context.config.icoSelectorThumbs).addClass(context.config.icoActiveClass).siblings().removeClass(context.config.icoActiveClass);
            $(context.config.gallerySelector).removeClass(context.config.galleryClassList).addClass(context.config.galleryClassThumbs);
        }
        responsive.config = {
            extraNarrow: 'br-n',
            narrow: 'br-n',
            medium: 'br-n',
            wide: 'br-m',
            extraWide: 'br-n'
        };
        $(window.document).trigger('breakPoint.changed', [responsive.currentBreakPoint]);
        return false;
    });

    $(context.config.icoSelectorList).on('click', function (e) {
        e.preventDefault();
        if (!$(context.config.icoSelectorList).hasClass(context.config.icoActiveClass)) {
            $(context.config.icoSelectorList).addClass(context.config.icoActiveClass).siblings().removeClass(context.config.icoActiveClass);
            $(context.config.gallerySelector).removeClass(context.config.galleryClassThumbs).addClass(context.config.galleryClassList);
        }
        responsive.config = {
            extraNarrow: 'br-m',
            narrow: 'br-m',
            medium: 'br-w',
            wide: 'br-w',
            extraWide: 'br-w'
        };
        $(window.document).trigger('breakPoint.changed', [responsive.currentBreakPoint]);
        return false;
    });

    return context;
};

exports.default = gallerySwitcher;

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpPricesComponent = __webpack_require__(374);

var _betslipInteracter = __webpack_require__(1509);

var _betslipInteracter2 = _interopRequireDefault(_betslipInteracter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initPrices() {
    new _rpPricesComponent.BestOdds();
    new _rpPricesComponent.BetHandler();
    _rpPricesComponent.priceButton.activate();
    var betslipInteracter = new _betslipInteracter2.default();
    betslipInteracter.init().then(function (betslipFeedName) {
        return _rpPricesComponent.pricesProvider.init(betslipFeedName);
    });
}

exports.default = initPrices;

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import './paidIcon';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _breakpointImageLoader = __webpack_require__(376);

var _breakpointImageLoader2 = _interopRequireDefault(_breakpointImageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rp1Index = function rp1Index($) {
    var self = this;
    self.opt = {
        indexId: null,
        sectionId: null,
        sectionsUrl: ''
    };
    self.$element = {
        showMore: null
    };

    /**
     * Cache elements
     *
     * @private
     * return rp1Index
     */
    var _initCacheElements = function _initCacheElements() {
        self.$element.showMore = $('.showMore');

        return this;
    };

    var replaceHTag = function replaceHTag() {
        if ($('section h1').length === 0) {
            var selector = $('section:first').find('h2.headlineWraper:first'),
                text = selector.text();
            selector.replaceWith(function () {
                return '<h1 class="headlineWraper">' + text + '</h1>';
            });
        }
    };

    /**
     * Initialize events
     *
     * @private
     * return rp1Index;
     */
    var _initEvents = function _initEvents(opt) {
        self.$element.showMore.click({ opt: opt }, function () {
            var id = $('span', this).data('id');
            var showMore = $(this);
            var sizes = opt.sizes;
            var currentScreenPosition = $('html').scrollTop();

            //animate the button "Show more"
            showMore.children('.text').animate({}, 500, 'linear', function () {
                showMore.animate({}, 500, 'linear', function () {
                    showMore.addClass('loader').animate({}, 5000, 'linear', function () {
                        var promise = showMore.animate({ borderSpacing: 1440 }, {
                            step: function step(now, fx) {
                                showMore.css('-webkit-transform', 'rotate(' + now + 'deg)');
                                showMore.css('-moz-transform', 'rotate(' + now + 'deg)');
                                showMore.css('transform', 'rotate(' + now + 'deg)');
                            },
                            duration: 4000,
                            easing: 'linear'
                        }).promise();

                        $.ajax({
                            url: self.opt.sectionsUrl + '/' + id + '/' + self.opt.indexId,
                            method: 'get',
                            success: function success(msg) {
                                promise.done(function () {
                                    showMore.parent().hide();
                                    showMore.parents('section.section').html(msg);

                                    // Paid icon hiding to logged premium users (NEWS-2051, NEWS-2113)
                                    /**
                                     * 2016-10-06: Feature temporary disabled according to Jira ticket below
                                     * @link https://racingpost.atlassian.net/browse/NEWS-2154
                                     */
                                    // new PaidIcon($, authReady);

                                    /**
                                     * 2016-10-10: To make image sources responsive on breakpoints after clicking Show More button
                                     * @link https://racingpost.atlassian.net/browse/NEWS-1297
                                     */
                                    var res = new _breakpointImageLoader2.default($(msg), $);
                                    res.changeImagesOnShowMoreClick(sizes);
                                    replaceHTag();

                                    var eventShowMore = new Event('showMoreAjaxDone');
                                    document.dispatchEvent(eventShowMore);

                                    // Hack for iOS white screen on Show More button click
                                    var wrapper = $('.ui-wrapper')[0];
                                    if (wrapper && navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
                                        wrapper.style.display = 'none';
                                        wrapper.offsetHeight; // no need to store this anywhere, the reference is enough
                                        wrapper.style.display = '';
                                        $("html").animate({ scrollTop: currentScreenPosition }, 1);
                                    }
                                });
                            },
                            error: function error() {
                                // Just hide spinning circle in case of error
                                promise.done(function () {
                                    showMore.parent().hide();
                                });
                            }
                        });
                    });
                });
            });
        });

        return self;
    };

    /**
     * Init options, events, element's cache
     *
     * @param opt
     * return rp1Index;
     */
    return {
        init: function init(opt) {
            $.extend(self.opt, opt);
            _initCacheElements();
            _initEvents(opt);
        }
    };
};exports.default = rp1Index;

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tabsSwitch = function tabsSwitch($, link) {
    var o = $(link);
    var p = o.parent('li');
    if (!p.hasClass('tabs__item-active')) {
        var i = p.parent('ul').children().index(p) + 1;
        var id = o.attr('data-story');
        o.parents('ul:first').find('li.tabs__item-active').removeClass('tabs__item-active').addClass('tabs__item');
        p.removeClass('tabs__item').addClass('tabs__item-active');
        $('div.storyContentWrp').removeClass('visible');
        $('div.links__block').removeClass('visible');

        $('#story-' + id + '-body').addClass('visible');
        $('#story-' + id + '-links').addClass('visible');

        var carouselDiv = $('#story-' + id + '-body').find('.slideShow__roll');
        if (carouselDiv && carouselDiv.size() > 0) {
            var fr = carouselDiv.data('fotorama');
            if (fr) {
                fr.resize();
            }
        }
        window.location.hash = 'tab-' + i;
        return false;
    }
};

exports.default = tabsSwitch;

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(170);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(171);

var _createClass3 = _interopRequireDefault(_createClass2);

var _rpNavigation = __webpack_require__(234);

var _rpMqBreakpoints = __webpack_require__(36);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Class works with navigation and using navigation component functionality */
var Navigation = function () {

    /**
     * Setting Cookie Policy by initializing
     */
    function Navigation() {
        (0, _classCallCheck3.default)(this, Navigation);

        this._props = {
            /**
             * {bool} Indicator for current breakpoint status: is Narrow or X-Narrow or nor
             */
            isLastBreakpointNarrow: false,
            /**
             * {object} Object from navigation component to get data about last active menu point
             */
            lastActiveItem: _rpNavigation.secondary.getActiveItem()
        };
    }

    /**
     * Subscribes on breakpoint change event and triggers it once
     * @param {string} title - Title of submenu link with arrow
     */


    (0, _createClass3.default)(Navigation, [{
        key: 'handleBreakpointChange',
        value: function handleBreakpointChange(title) {
            this._props.title = title;
            this.eventTrigger(this._props.title);

            var context = this;
            $(window).on('rpBreakpointsSwitch', function (event) {
                context.eventTrigger(context._props.title, event);
            });
        }

        /**
         * Actions check changing breakpoint to narrow and ex-narrow or vise versa and show/hide additional title to arrow
         * @param {string} title - Title of submenu link with arrow
         * @param {object} event - Event object from breakpointListener
         */

    }, {
        key: 'eventTrigger',
        value: function eventTrigger(title) {
            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var code = event ? event.detail.breakpoint.code : _rpMqBreakpoints2.default.current().code;
            if (!this._props.isLastBreakpointNarrow && (this._props.isLastBreakpointNarrow = this.isNarrowOrXNarrow(code))) {
                _rpNavigation.secondary.addItem(title, '#', 1);
                var menuPoint = _rpNavigation.secondary.getItemByPosition(1);
                _rpNavigation.secondary.setActiveItem(menuPoint);
                _rpNavigation.secondary.render();
                $('#secondaryNav').find('.ui-link_marked').parent().remove();
            } else if (this._props.isLastBreakpointNarrow && !(this._props.isLastBreakpointNarrow = this.isNarrowOrXNarrow(code))) {
                _rpNavigation.secondary.removeItem(_rpNavigation.secondary.getActiveItem());
                _rpNavigation.secondary.setActiveItem(this._props.lastActiveItem);
                _rpNavigation.secondary.render();
            }
        }

        /**
         * Get the answer for a question - is that code narrow or ex-narrow?
         * @param {string} code - List of possible codes: [n, xn, m, w, xw]
         * @returns {boolean}
         */

    }, {
        key: 'isNarrowOrXNarrow',
        value: function isNarrowOrXNarrow(code) {
            return code === 'n' || code === 'xn' ? true : false;
        }
    }]);
    return Navigation;
}();

exports.default = Navigation;
;

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(239);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(170);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(171);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = __webpack_require__(119);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _EVENTS = __webpack_require__(1510);

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _getDiffusionConfig = __webpack_require__(1511);

var _getDiffusionConfig2 = _interopRequireDefault(_getDiffusionConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScribbleWidgetInteracter = function () {
    function ScribbleWidgetInteracter() {
        (0, _classCallCheck3.default)(this, ScribbleWidgetInteracter);

        this.decimalOdds = false;
        this.diffusionConfig = {};

        this.target = document.querySelector('iframe[class*="scrbbl-embed"]').contentWindow;
        this.senderName = 'RP1 Main Window';
        this.trustedSenderDomain = 'embed.scribblelive.com';
        this.trustedSenderName = 'Scribble Live Blog widget iFrame';

        this.onPostMessage = this.onPostMessage.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.onBetslipBookmakerChanged = this.onBetslipBookmakerChanged.bind(this);
    }

    (0, _createClass3.default)(ScribbleWidgetInteracter, [{
        key: 'init',
        value: function init() {
            this.log('init()');

            var customizeSettingsCookie = _jsCookie2.default.get('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            this.diffusionConfig = (0, _getDiffusionConfig2.default)();
            var segmentKey = document.querySelector('body').getAttribute('data-segment-key');
            this.sendPostMessage({
                eventName: _EVENTS2.default.SCRIBBLE_INITIALIZED,
                eventDetail: {
                    diffusionConfig: this.diffusionConfig,
                    segmentKey: segmentKey
                }
            });
        }
    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            this.log('requestSelectedBookmaker()');

            // Trigger event for Betslip to broadcast current bookmaker via EVENTS.BETSLIP_BOOKMAKER
            var betslipEvent = new CustomEvent(_EVENTS2.default.BETSLIP_BOOKMAKER_GET);
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            this.log('onBetslipInitialized()');

            this.requestSelectedBookmaker();
        }
    }, {
        key: 'onBetslipBookmakerChanged',
        value: function onBetslipBookmakerChanged(_ref) {
            var eventName = _ref.type,
                detail = _ref.detail;

            this.log('onBetslipBookmakerChanged(', eventName, ',', detail, ')');

            this.sendPostMessage({
                eventName: eventName,
                eventDetail: (0, _assign2.default)(detail, {
                    decimalOdds: this.decimalOdds,
                    diffusionConfig: this.diffusionConfig
                })
            });
        }
    }, {
        key: 'sendPostMessage',
        value: function sendPostMessage(message) {
            this.log('sendPostMessage(', message, ')');

            this.target.postMessage((0, _assign2.default)(message, { sender: this.senderName }), '*');
        }
    }, {
        key: 'onPostMessage',
        value: function onPostMessage(_ref2) {
            var origin = _ref2.origin,
                _ref2$data = _ref2.data,
                sender = _ref2$data.sender,
                eventName = _ref2$data.eventName,
                eventDetail = _ref2$data.eventDetail;

            if (origin.includes(this.trustedSenderDomain) && sender === this.trustedSenderName) {
                this.log('[POST MESSAGE RECEIVED]:', eventName, eventDetail);

                switch (eventName) {
                    case _EVENTS2.default.SCRIBBLE_INITIALIZED:
                    case _EVENTS2.default.BETSLIP_BOOKMAKER_GET:
                        this.requestSelectedBookmaker();
                        break;

                    case _EVENTS2.default.BETSLIP_MAKE_SELECTION:
                        this.onMessageBetslipMakeSelection(eventDetail);
                        break;

                    default:
                        // No default action
                        break;
                }
            }
        }
    }, {
        key: 'onMessageBetslipMakeSelection',
        value: function onMessageBetslipMakeSelection(eventDetail) {
            this.log('onMessageBetslipMakeSelection(eventDetail:', eventDetail, ')');

            // Trigger event for Betslip to open selection
            var makeSelectionEvent = new CustomEvent(_EVENTS2.default.BETSLIP_MAKE_SELECTION, { detail: eventDetail });
            document.dispatchEvent(makeSelectionEvent);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            window.addEventListener(_EVENTS2.default.MESSAGE, this.onPostMessage, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_INITIALIZED, this.onBetslipInitialized, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER, this.onBetslipBookmakerChanged, false);
            document.addEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER_CHANGED, this.onBetslipBookmakerChanged, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            window.removeEventListener(_EVENTS2.default.MESSAGE, this.onPostMessage, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_INITIALIZED, this.onBetslipInitialized, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER, this.onBetslipBookmakerChanged, false);
            document.removeEventListener(_EVENTS2.default.BETSLIP_BOOKMAKER_CHANGED, this.onBetslipBookmakerChanged, false);
        }
    }, {
        key: 'log',
        value: function log() {
            if (false) {
                var _console;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                (_console = console).log.apply(_console, ['[MAIN] ' + this.constructor.name + ' ->'].concat(args));
            }
        }
    }]);
    return ScribbleWidgetInteracter;
}();

exports.default = ScribbleWidgetInteracter;

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(132);

var _keys2 = _interopRequireDefault(_keys);

var _rpNavigation = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publicIndexes = function publicIndexes($, Responsive) {
    function more(Rp1Index) {
        var showMore = new Rp1Index($);

        var sizes = {
            '.sectionA__image': {
                extraNarrow: 'br-n',
                narrow: 'br-n',
                medium: 'br-n',
                wide: 'br-n',
                extraWide: 'br-n'
            },
            '.sectionB__image': {
                extraNarrow: 'br-n',
                narrow: 'br-xn',
                medium: 'br-xn',
                wide: 'br-xn',
                extraWide: 'br-xn'
            },
            '.sectionD__image': {
                extraNarrow: 'br-m',
                narrow: 'br-m',
                medium: 'br-w',
                wide: 'br-w',
                extraWide: 'br-w'
            },
            '.sectionI__image': {
                extraNarrow: 'br-n',
                narrow: 'br-xn',
                medium: 'br-xn',
                wide: 'br-n',
                extraWide: 'br-xn'
            }
        };
        var keys = (0, _keys2.default)(sizes);
        for (var key in keys) {
            var cls = keys[key];
            var res = new Responsive($(cls), $);
            res.config = sizes[cls];
            res.BreakPointListener();
        }

        showMore.init({
            indexId: $('.content').data('index'),
            sectionsUrl: $('.content').data('url'),
            sizes: sizes
        });
    }

    function startHashClickHandle(selector) {
        $('#secondaryNav').on('click', selector, function (e) {
            var target = $('#' + this.hash.substr(this.hash.lastIndexOf('#') + 1));
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                _rpNavigation.secondary._closeNarrow();
                return false;
            }
        });
    }

    return {
        showMoreDisplay: more,
        startHashClickHandle: startHashClickHandle
    };
};

exports.default = publicIndexes;

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baguetteBox = __webpack_require__(375);

var _baguetteBox2 = _interopRequireDefault(_baguetteBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gallery = function gallery($, baguetteBox, blockId) {
    var mediaBlock = $('#' + blockId),
        prevLink = mediaBlock.find('.slideShow__pager-prev'),
        nextLink = mediaBlock.find('.slideShow__pager-next'),
        captionWrapper = mediaBlock.find('.slideShow__textHolder'),
        currentInfoWrapper = mediaBlock.find('.slideShow__pager-current'),
        slideShow = mediaBlock.find('.slideShow').length > 0 ? mediaBlock.find('.slideShow') : mediaBlock,
        currentPreImageElement = slideShow.children('a:visible'),
        totalImages = slideShow.children('a').length;

    prevLink.click(function (e) {
        e.preventDefault();
        currentPreImageElement = slideShow.children('a').filter(function (index, elem) {
            return $(elem).css('display') !== 'none';
        });
        if (currentPreImageElement.index() > 0) {
            currentInfoWrapper.html(currentInfoWrapper.html() * 1 - 1);
            currentPreImageElement.hide().prev().show();
            captionWrapper.html(currentPreImageElement.prev().data('caption'));
            if (currentPreImageElement.prev().data('caption') === '') {
                captionWrapper.hide();
            } else {
                captionWrapper.show();
            }

            if (currentPreImageElement.index() === 1) {
                prevLink.addClass('disabled');
            }
            if (currentPreImageElement.index() + 2 !== totalImages) {
                nextLink.removeClass('disabled');
            }
        }

        return false;
    });

    nextLink.click(function (e) {
        e.preventDefault();
        currentPreImageElement = slideShow.children('a').filter(function (index, elem) {
            return $(elem).css('display') !== 'none';
        });
        if (currentPreImageElement.index() + 1 < totalImages) {
            currentInfoWrapper.html(currentInfoWrapper.html() * 1 + 1);
            currentPreImageElement.hide().next().show();
            captionWrapper.html(currentPreImageElement.next().data('caption'));
            if (currentPreImageElement.next().data('caption') === '') {
                captionWrapper.hide();
            } else {
                captionWrapper.show();
            }

            if (currentPreImageElement.index() + 2 === totalImages) {
                nextLink.addClass('disabled');
            }
            if (currentPreImageElement.index() >= 0) {
                prevLink.removeClass('disabled');
            }
        }

        return false;
    });

    (function () {
        if (currentPreImageElement.data('caption') === '') {
            captionWrapper.hide();
        }

        if (totalImages !== 1) {
            nextLink.removeClass('disabled');
        }

        slideShow.find('a').each(function (num, elem) {
            $(elem).removeAttr('onClick');
        });
        slideShow.children('svg').on('click', function (event) {
            $(event.currentTarget).parent().children('a:visible')[0].click();
        });
    })();

    var options = {
        captions: true, // true|false|callback(element) - Display image captions
        buttons: true, // 'auto'|true|false - Display buttons
        animation: 'slideIn', // 'slideIn'|'fadeIn'|false - Animation type
        afterShow: function afterShow() {}, // callback - To be run after showing the overlay
        afterHide: null, // callback - To be run after hiding the overlay
        onChange: function onChange(index, total) {
            $('#baguetteBox-num').html(index + 1 + ' of ' + total);

            var $curEl = $('#baguetteBox-slider .full-image:eq(' + index + ')');
            $curEl.find('figcaption').show();
            $curEl.siblings().find('figcaption').hide();

            if (index === 0) {
                $('#previous-button').addClass('disabled');
            } else {
                $('#previous-button').removeClass('disabled');
            }

            if (index + 1 === total) {
                $('#next-button').addClass('disabled');
            } else {
                $('#next-button').removeClass('disabled');
            }
        } // callback(currentIndex, imagesElements.length) - When image changes
    };

    var touchStartX, touch;
    var touchFlag = false;
    var touchStartHandler = function touchStartHandler(event) {
        touchStartX = event.changedTouches[0].pageX;
    };
    var touchMoveHandler = function touchMoveHandler(event) {
        if (touchFlag) {
            return;
        }

        touch = event.changedTouches[0] || event.touches[0];
        if (touch.pageX - touchStartX > 20) {
            event.preventDefault();
            touchFlag = true;
            prevLink.trigger('click');
        } else if (touch.pageX - touchStartX < -20) {
            event.preventDefault();
            touchFlag = true;
            nextLink.trigger('click');
        }
    };
    var touchEndHandler = function touchEndHandler(event) {
        touchFlag = false;
    };
    var clickHandler = function clickHandler(event) {
        event.preventDefault();
    };
    function startHandleTouch() {
        slideShow[0].addEventListener('touchstart', touchStartHandler, false);
        slideShow[0].addEventListener('touchmove', touchMoveHandler, false);
        slideShow[0].addEventListener('touchend', touchEndHandler, false);
        slideShow[0].addEventListener('click', clickHandler, false);
    }
    function stopHandleTouch() {
        slideShow[0].removeEventListener('touchstart', touchStartHandler, false);
        slideShow[0].removeEventListener('touchmove', touchMoveHandler, false);
        slideShow[0].removeEventListener('touchend', touchEndHandler, false);
        slideShow[0].removeEventListener('click', clickHandler, false);
    }

    var box = baguetteBox;
    box.run(slideShow === mediaBlock ? '#' + blockId : '#' + blockId + ' .slideShow', options);

    return {
        run: function run(newBlockId) {
            var slideShowSelector = $('#' + newBlockId + ' > .slideShow').length > 0 ? '#' + newBlockId + ' > .slideShow' : '#' + newBlockId;
            var slideShow = $(slideShowSelector);

            $(slideShow).children('svg').on('click', function () {
                $(slideShow).children('a:visible > img').trigger('click');
            });
            box.run(slideShowSelector, options);
        },
        destroy: function destroy() {
            box.destroy();
        },
        startHandle: startHandleTouch,
        stopHandle: stopHandleTouch
    };
};

exports.default = gallery;

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = youTubeTracking;

var _rpAnalytics = __webpack_require__(71);

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function youTubeTracking() {
    var youTubePlayersOnPage = document.querySelectorAll('iframe[src*="youtu"]');

    /*
     * Load Youtube Iframe API script
     * Remove unused stuff from video attr and add origin host
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    if (youTubePlayersOnPage.length !== 0) {
        loadYoutubeIframeScript("https://www.youtube.com/iframe_api");
        for (var i = 0; i < youTubePlayersOnPage.length; i++) {
            var url = youTubePlayersOnPage[i].getAttribute('src');
            var connectionSymbol = url.indexOf('?') === -1 ? '?' : '&';
            url = url.replace('?rel=0', '') + connectionSymbol + 'origin=' + window.location.protocol + '//' + window.location.hostname;
            youTubePlayersOnPage[i].setAttribute('src', url);
        }
    }

    /*
     * This script needed for logging user actions on Youtube players
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    function loadYoutubeIframeScript(src) {
        var s = void 0;
        s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = src;
        document.body.appendChild(s);
    }

    /*
     * Getting all Youtube players on page and adding event handlers
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    var player = void 0;
    window.onYouTubeIframeAPIReady = function () {
        var playersOnPage = document.querySelectorAll('.embed-responsive-item');
        var countPlayersOnPage = playersOnPage.length;

        for (var _i = 0; _i < countPlayersOnPage; _i++) {
            var playerId = playersOnPage[_i].id;

            player = new YT.Player(playerId, {
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
        }
    };

    /*
     * Tracking all events happened with Youtube players
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    function onPlayerStateChange(event) {
        // get player data from event to avoid loop event closure issue
        var player = event.target;
        switch (event.data) {
            case YT.PlayerState.PLAYING:
                segmentio.track('Video Played', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    duration: player.getDuration()
                });
                break;
            case YT.PlayerState.PAUSED:
                segmentio.track('Video Paused', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    pausedAt: player.getCurrentTime()
                });
                break;
            case YT.PlayerState.ENDED:
                segmentio.track('Video Finished', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    duration: player.getDuration()
                });
                break;
            default:
                return;
        }
    }
};

/***/ })

},[1508]);


// WEBPACK FOOTER //
// app.min.js